module.exports = "/static/assets/abf3df9b90326668ad23bcdaa3f227c1.png";